import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@aureskonnect/react-ui";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import ErrorToast from "@components/Common/ErrorTost";

import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";

import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";

import { store } from "../../../../components/VerticalLayout/store";
import {
    store as FiscalYear,
    setNumberArchived,
    setNumberActive,
    setLocalShop,
    setIdsLocalShop,
    setFiscalYearData,
    setArchivedFiscalYearFranchise,
    setFiscalYearFranchise,
    setDataArchive,
    setDataFranchiseArchive,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setValidationAction,
} from "../store";

import { CustomIcons } from "./CustomIcons";
import { ActionColumn } from "./ActionColumn";
import { ConfirmationActiveFiscalYear } from "../ConfirmationActiveFiscalYear";
import HistoryModal from "../HistoryModal";
import FiscalYearForm from "./FiscalYearForm";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

export default function FiscalOfYear({
    isFiscalYearArchived,
    setIsFiscalYearArchived,
}: any) {
    const { t } = useTranslation();
    const { oneShop, userID, franchiseID, shopID } = useSnapshot(store);
    const {
        fiscalYearData,
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
        modify,
    } = useSnapshot(FiscalYear);

    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [isConsult, setIsConsult] = React.useState<boolean>(false);
    const [
        isAddNewFiscalYearButtonClicked,
        setIsAddNewFiscalYearButtonClicked,
    ] = useState(false);
    const [rowData, setRowData] = useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isHistoryModalOpened, setIsHistoryModalOpened] = React.useState<
        boolean
    >(false);
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [shopId, setShopId] = React.useState<string | number>(
        oneShop ? shopID : 0
    );
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [dataTable, setDataTable] = React.useState<any>({});
    const [isAddFiscalYearClicked, setIsAddFiscalYearClicked] = React.useState<
        boolean
    >(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const urlArchive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/fiscal_year_archived?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;

    const urlActive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/fiscal_year?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 0,
            columnName: t("Start exercise"),
            customJsx: (e: any) => (
                <span>{e.selectedRow[t("Start exercise")]}</span>
            ),
            filterName: t("Start exercise"),
            canFilter: true,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setShopId={setShopId}
                    setRowData={setRowData}
                    setFiscalYear={setFiscalYear}
                    setIsModalOpened={setIsModalOpened}
                    isModalOpened={isModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    isHistoryModalOpened={isHistoryModalOpened}
                    setSelectedRows={setSelectedRows}
                    isOneShop={true}
                    isFiscalYearArchived={isFiscalYearArchived}
                    isAddFiscalYearClicked={isAddFiscalYearClicked}
                    setIsAddFiscalYearClicked={setIsAddFiscalYearClicked}
                    selectedRows={selectedRows}
                    setLocalFilterActive={setLocalFilterActive}
                    setIsConsult={setIsConsult}
                />
            ),
            disableFilter: false,
        },
    ];

    function NumberActiveAndArchive() {
        if (
            dataTable.othersData !== undefined &&
            dataTable.othersData.numberActive !== undefined
        ) {
            setNumberActive(dataTable.othersData.numberActive);
            setNumberArchived(dataTable.othersData.numberArchive);
        } else {
            setNumberActive(0);
            setNumberArchived(0);
        }
    }

    React.useEffect(() => {
        if (filterActive) setIsAddFiscalYearClicked(false);
    }, [filterActive]);

    React.useEffect(() => {
        let localShop: string[] = [];
        let idsLocalShop: string[] = [];
        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
                localShop.push(el.shopId);

            idsLocalShop.push(el.Id);
        });
        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);
        setFiscalYearData(dataTable);
        setArchivedFiscalYearFranchise(dataTable);
        setFiscalYearFranchise(dataTable);
        setDataArchive(
            dataTable.othersData !== undefined
                ? dataTable.othersData.dataArchive
                : []
        );
        setDataFranchiseArchive(
            dataTable.othersData !== undefined
                ? dataTable.othersData.dataOfFranchiseArchive
                : []
        );
    }, [selectedRows, dataTable, t]);

    React.useEffect(() => {
        NumberActiveAndArchive();
        // eslint-disable-next-line
    }, [dataTable]);

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        setDataIsUpdated(!dataIsUpdated);
        // eslint-disable-next-line
    }, [i18nextLng]);
    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: isAddFiscalYearClicked
                        ? "2fr 1fr "
                        : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={isFiscalYearArchived ? urlArchive : urlActive}
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    canExpand={false}
                    canSelect
                    customSelect
                    setData={setDataTable}
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <React.Fragment>
                            {modify === true ? (
                                <>
                                    {isAddFiscalYearClicked !== true ? (
                                        <div className="d-flex justify-content-start align-items-center ml-2">
                                            <span
                                                onClick={() => {
                                                    setFiscalYear([]);
                                                    if (
                                                        fiscalYearData.data
                                                            .length > 0 &&
                                                        oneShop
                                                    ) {
                                                        ErrorToast(
                                                            t(
                                                                "Attention, a shop cannot have more than one fiscal year"
                                                            )
                                                        );
                                                    } else {
                                                        setIsAddFiscalYearClicked(
                                                            !isAddFiscalYearClicked
                                                        );
                                                    }
                                                    setLocalFilterActive(false);
                                                }}
                                                className={`${classnames(
                                                    "w-100 ml-3 cmn_btn_openForm",
                                                    {
                                                        "not-allowed-icon__clz": isFiscalYearArchived,
                                                    }
                                                )}`}
                                            >
                                                <CustomMainColorButtonWithIcon
                                                    icon="PlusIcon"
                                                    iconPosition="left"
                                                    rounded
                                                    variant="primary"
                                                >
                                                    {t("Add fiscal year")}
                                                </CustomMainColorButtonWithIcon>
                                                <div></div>
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-start">
                                            <CustomMainColorIconButton
                                                icon="PlusIcon"
                                                className=" exf_btn_FRreset"
                                                rounded
                                                disabled={
                                                    fiscalYear.length === 0
                                                        ? false
                                                        : true
                                                }
                                                onClick={() => {
                                                    if (isEdited === true)
                                                        setIsInInitializationModalOpened(
                                                            true
                                                        );
                                                }}
                                            >
                                                <PlusIcon
                                                    height={20}
                                                    width={20}
                                                    fill="white"
                                                />
                                            </CustomMainColorIconButton>
                                            <div className="mt-3"></div>
                                        </div>
                                    )}
                                </>
                            ) : null}
                            <ActionColumn
                                setIsHistoryModalOpened={
                                    setIsHistoryModalOpened
                                }
                                isHistoryModalOpened={isHistoryModalOpened}
                                selectedRows={selectedRows}
                                setDataIsUpdated={setDataIsUpdated}
                                setIsModalOpened={setIsModalOpened}
                                isModalOpened={isModalOpened}
                                isFiscalYearArchived={isFiscalYearArchived}
                                setIsFiscalYearArchived={
                                    setIsFiscalYearArchived
                                }
                                setIsAddFiscalYearClicked={
                                    setIsAddFiscalYearClicked
                                }
                            />
                        </React.Fragment>
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    canMovedCheckboxLeftOnExpand
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="FiscalYear"
                />
                {isAddFiscalYearClicked ? (
                    <FiscalYearForm
                        isAddFiscalYearClicked={isAddFiscalYearClicked}
                        setIsAddFiscalYearClicked={setIsAddFiscalYearClicked!}
                        setDataIsUpdated={setDataIsUpdated}
                        dataFiscalYear={fiscalYear}
                        isAddNewFiscalYearButtonClicked={
                            isAddNewFiscalYearButtonClicked
                        }
                        setDataFiscalYear={setFiscalYear}
                        setIsEdited={setIsEdited}
                        setLocalFilterActive={setLocalFilterActive}
                        setIsConsult={setIsConsult}
                        isConsult={isConsult}
                    />
                ) : null}
            </div>
            {isActionsClicked === true ? (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            <ConfirmationActiveFiscalYear
                setIsModalOpened={setIsModalOpened}
                isModalOpened={isModalOpened}
            />
            {isInInitializationModalOpened === true ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewFiscalYearButtonClicked}
                    isClicked={isAddNewFiscalYearButtonClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isHistoryModalOpened ? (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                    rowData={rowData}
                    isOneShop={true}
                    setData={setDataIsUpdated}
                />
            ) : null}
        </React.Fragment>
    );
}
